import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { PageTitle } from '@/shared/ui/PageTitle/PageTitle';
import { NewsList } from './NewsList';
import { NewsEditor } from './NewsEditor';
import s from './NewsPage.module.scss';

const NewsPage: React.FC = () => {
  const location = useLocation();
  const { id } = useParams<{ id: string }>();
  const isCreate = location.pathname.endsWith('/create');
  const isEdit = Boolean(id) && location.pathname.includes('/edit');

  return (
    <div className={s.container}>
      <PageTitle title={isCreate ? 'Создание новости' : isEdit ? 'Редактирование новости' : 'Управление новостями'} />
      {isCreate || isEdit ? <NewsEditor id={id ? Number(id) : undefined} /> : <NewsList />}
    </div>
  );
};

export default NewsPage;
